import React from "react"
import { Fade } from "react-awesome-reveal"

const LocationFirstInfo = () => (
  <section className="location-info">
    <div className="container">
      <div className="row location-info__holder">
        <div className="col-12 col-lg-5 location-info__image location-info__image--full">
          <Fade delay={150} direction={"left"} triggerOnce>
            <img
              className="image-shadow lazyload"
              data-src={require("../../assets/img/location-info3.jpg")}
              alt=""
            />
          </Fade>
        </div>
        <div className="col-12 col-lg-6 col-xxl-5 offset-lg-1 location-info__content">
          <Fade delay={300} direction={"right"} triggerOnce>
            <h2 className="content__title mb-50">
              Trasy <br />
              spacerowo-rowerowe
            </h2>
            <p className="content__text content__text--mobile-center">
              W bezpośrednim sąsiedztwie budynku znajduje się Młynówka
              Królewska, czyli aż 4,5 km zielonych tras dla pieszych i
              rowerzystów. Okolica KW51 sprzyja aktywnemu wypoczynkowi po pracy.
            </p>
          </Fade>
        </div>
      </div>
    </div>
  </section>
)

export default LocationFirstInfo
